import React, { useContext } from 'react'

import s from '../Carts.module.scss'
import CartNumberSelect from '../CartSelect/CartNumberSelect'
import { formatMoneyTo } from '~/helper'
import { toast } from 'react-hot-toast'
import { AppContext } from '~/context/AppContext'
import axiosConfig from '~/api/axios-config'

const CartItem = ({
	name,
	quantities,
	price,
	img,
	id,
	cartId,
	selected,
	onChangeSelected,
	onIncrease,
	onDecrease,
}) => {
	const { setCartList } = useContext(AppContext)

	const handleDeleteCart = () => {
		axiosConfig
			.delete(`/cart`, { params: { _id: cartId } })
			.then((res) => {
				toast.success(res?.data?.msg)
			})
			.catch((err) => console.log(err))
		setCartList((prev) => prev.filter((cart) => cart._id !== cartId))
	}
	return (
		<div className={s.item}>
			<input
				type='checkbox'
				checked={selected}
				onChange={() => onChangeSelected(cartId)}
			/>
			<a
				href={`/product/${id}`}
				className={s.imageWrap}
			>
				<img
					src={img}
					alt=''
					className={s.image}
				/>
			</a>
			<div className={s.info}>
				<a
					href={`/product/${id}`}
					className={s.name}
				>
					{name}
				</a>
				<div className={s.infoBottom}>
					<div className={s.infoBottomLeft}>
						<span className={s.quantity}>Số lượng: </span>
						<CartNumberSelect
							onIncrease={() => onIncrease(cartId)}
							onDecrease={() => onDecrease(cartId)}
							quantities={quantities}
						/>
					</div>
					<div className={s.infoBottomRight}>
						<h5 className={s.cost}>{formatMoneyTo(price)}</h5>
						<span
							className={s.delete}
							onClick={handleDeleteCart}
						>
							Bỏ sản phẩm
						</span>
					</div>
				</div>
			</div>
		</div>
	)
}

export default CartItem
